import { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getpastConfYears, getpastConfProceedingsType } from '../../services/pastConfProceedingsUploadServices';
import { Button, Modal, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import { validateFile } from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const Pastconfproceedingsupload = () => {
  const [errors, setErrors] = useState({});  
  const [loading, setLoading] = useState(false);
  
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null, 
    uploadedfile1: null,  
    year: '', 
    proc_type: '',
    proc_img_alt: ''  
  });
  const [modalType, setModalType] = useState(''); // 'add' or 'edit'
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setselectedData] = useState(null);
  const [pastConfYears, setpastConfYears] = useState([]);
  const [pastConfProceedingsType, setpastConfProceedingsType] = useState([]);

  
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);


  // Fetch data from API
      const fetchData = useCallback(async () => {
         setLoading(true);
         try{
        const response = await getData();
        setData(response);
         }
         catch(error){
          console.error('Failed to fetching data:', error);
        }
        finally {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      }, []);
  
      useEffect(() => {
        fetchData();
      }, [fetchData]);
  
  useEffect(() => {
      const fetchpastConfYears = async () => {
        try {
          const data = await getpastConfYears(); // Fetch data from the service
          setpastConfYears(data); // Set the types in state
        } catch (error) {
          console.error('Error fetching  type:', error);
        }
      };
      fetchpastConfYears();
    }, []);

    useEffect(() => {
        const fetchpastConfProceedingsType = async () => {
          try {
            const data = await getpastConfProceedingsType(); // Fetch data from the service
            setpastConfProceedingsType(data); // Set the types in state
          } catch (error) {
            console.error('Error fetching type :', error);
          }
        };
        fetchpastConfProceedingsType();
      }, []);



  const validateForm = () => {
  const newErrors = {};
  if (!formData.uploadedfile && formData.uploadedfile === null) {
    if (!errors.uploadedfile) newErrors.uploadedfile = "Upload Proceeding  is required";
  }
  if (!formData.uploadedfile1 && formData.uploadedfile1 === null) {
    if (!errors.uploadedfile1) newErrors.uploadedfile1 = "Proceeding Photo is required";
  }
  if (!formData.year) newErrors.year = "Year is required";
  if (!formData.proc_type) newErrors.proc_type = "Proceeding Type  is required";
  if (!formData.proc_img_alt) newErrors.proc_img_alt = "Alt Photo Name is required";

  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
};

    // Handle file selection
    const handleChange = async(e) => {
          try {
          const { name, value, files } = e.target;
          const file = files?.[0]
          
          // Create a copy of the current form data
          let updatedData = { ...formData };
          let updatedErrors = { ...errors };
          if (file) {
            const fileType = file.type.includes("image") ? "img" : "pdf";
            const isValid = await validateFile(file, setErrors,name,fileType);
            if (isValid) {
              updatedData[name] = file;
              updatedErrors[name] = '';
            }
            else{
              return ; // Don't update if invalid
            }
          }
          else{
            updatedData[name] = value;
            if (value) {
            updatedErrors[name] = ''; // Clear error if corrected
          }
          }
           setFormData(updatedData);
           setErrors(updatedErrors);
        } catch (error) {
          console.error("Error in handleChange:", error);
        }
        };
    
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!validateForm()) {
        return
      }
      try{
      const form = new FormData();
      form.append('id', formData.id);
      form.append('year', formData.year);
      form.append('proc_type', formData.proc_type);
      form.append('proc_img_alt', formData.proc_img_alt);
      form.append('uploadedfile', formData.uploadedfile);
      form.append('uploadedfile1', formData.uploadedfile1);
      if (modalType === 'add') {
        const result = await addData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Saved Successfully!", {
                        position: 'top-right',
                      });
        } else {
          toast.error(result.message ||"Failed to update data. Please try again.", {
                        position: 'top-right',
                      });
        }
      } else if (modalType === 'edit') {
        const result = await updateData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Updated Successfully!", {
                        position: 'top-right',
                      });
        } else {
          toast.error(result.message ||"Failed to update data. Please try again.", {
                        position: 'top-right',
                      });
        }
      }
    }
      catch(error){
        console.error("Error during form submission:", error);
      }
    };

    const handleDelete = async () => {
      try{
      if (selectedData) {
        const result = await deleteData(selectedData.id);
        if (result.status === 200) {
          fetchData();
          setShowDeleteConfirmModal(false);
          toast.success("Deleted Successfully!", {
                        position: 'top-right',
                      });
        } else {
          toast.error("Failed to Delete data. Please try again.", {
                        position: 'top-right',
                      });
        }
      }
    }
    catch(error){
      console.log('Failed to Delete data. Please try again.',error);
    }
    };
  
    const openModal = (type, data = {
        id: null,
        uploadedfile: null,
        uploadedfile1: null,
        year: '', 
        proc_type: '',
        proc_img_alt: ''
      }) => {
        setModalType(type);
        setFormData(data);
        setShowModal(true);
      };

  const closeModal = () => {
    setShowModal(false);
  };

  const openDeleteConfirmModal = (data) => {
    setselectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false);
    setselectedData(null);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


   // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
        const filtered =  data.filter(
          (data) =>
          data.proc_type.toLowerCase().includes(searchText.toLowerCase()) 
        );
        const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        return sortedData;
      }, [data, searchText]);
    

  const columns = [
    {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '80px',
      },
      {
        name: 'Year',
        selector: (row) => row.year,
        cell: (row) => (
            <span title={row.year}>
              {row.year}
            </span>
          ),
        sortable: true,
    },
    {
        name: 'Proceeding Type',
        selector: (row) => row.proc_type,
        cell: (row) => (
            <span title={row.proc_type}>
              {row.proc_type}
            </span>
          ),
        sortable: true,
    },
    {
        name: ' Proceeding Preview',
        selector: (row) => <img src={row.proc_img} width="100" alt={row.proc_img_alt} 
        style={{ width: '60px', height: '40px', objectFit: 'cover' }}
        crossOrigin="anonymous"  />,
        sortable: false,
    },
    {
        name: 'PDF',
        selector: row => row.proc_pdf,
        sortable: true,
        cell: row => row.proc_pdf ? (
            <a className="btn btn-sm bg-success text-light rounded" href={row.proc_pdf} target="_blank" rel="noopener noreferrer">
                <i className="mdi mdi-arrow-down-bold text-light"></i> Download
            </a>
        ) : 'No PDF Available',
    },
    {
      name: 'Actions',
      cell: (row) => (
                <div>
                  <Button
                    className="me-2"
                    variant="warning"
                    size="sm"
                    onClick={() => openModal('edit', {
                      id: row.id,
                      uploadedfile: row.proc_pdf, 
                      uploadedfile1: row.proc_img,
                      year: row.year, 
                      proc_type: row.proc_type, 
                      proc_img_alt: row.proc_img_alt, 
                    })}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => openDeleteConfirmModal(row)}
                  >
                    Delete
                  </Button>
                </div>
              ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className='mb-3 fs-4'>Past Events Pages / Past Conferences <b>/ Conference Proceedings</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
          

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} className="modal-lg" onHide={closeModal} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
                <div className='row'>
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>Past Conference Year <small className='text-danger'> * </small></Form.Label>
                    <Form.Control className="form-select mb-3" as="select" name="year" value={formData.year} onChange={handleChange} isInvalid={!!errors.year}>
                        <option value="">Select Year</option>
                        {pastConfYears.map((years) => (
                            <option key={years.year} value={years.year}>
                            {years.display_year}
                            </option>
                        ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.year}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>Proceeding Type<small className='text-danger'> * </small></Form.Label>
                    <Form.Control className="form-select mb-3" as="select" name="proc_type" value={formData.proc_type} onChange={handleChange} isInvalid={!!errors.proc_type} >
                        <option value="">Select Proceeding Type</option>
                        {pastConfProceedingsType.map((proceedings_type) => (
                            <option key={proceedings_type.proceedings_type} value={proceedings_type.proceedings_type}>
                            {proceedings_type.proceedings_type}
                            </option>
                        ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.proc_type}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>
                    Upload Proceeding <small className='text-danger'> * </small> <small className="text-primary form-label-note"> (Format:pdf | Size:less than 8mb)</small>
                    </Form.Label>
                    <Form.Control
                        type="file"
                        name="uploadedfile"
                        onChange={handleChange}
                        isInvalid={!!errors.uploadedfile}
                        accept='application/pdf'
                    />
                <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>

                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>
                    Proceeding Photo <small className='text-danger'> * </small> <small className="text-primary form-label-note"> (Dimension:200x280 | Size:30kb to 60kb)</small>
                    </Form.Label>
                    <Form.Control
                        type="file" 
                        name="uploadedfile1"
                        onChange={handleChange}
                        isInvalid={!!errors.uploadedfile1}
                        accept='image/*'
                    />
                    <Form.Control.Feedback type="invalid">{errors.uploadedfile1}</Form.Control.Feedback>

                </Form.Group>               
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Alt Photo Name <small className='text-danger'> * </small></Form.Label>
                  <Form.Control
                    type="text"
                    name="proc_img_alt"
                    value={formData.proc_img_alt}
                    onChange={handleChange}
                    isInvalid={!!errors.proc_img_alt}
                  />
                  <Form.Control.Feedback type="invalid">{errors.proc_img_alt}</Form.Control.Feedback>
                </Form.Group>             
                </div>

                <Modal.Footer className='border-0'>
                  <Button variant="secondary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    {modalType === 'add' ? 'Add' : 'Save'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={closeDeleteConfirmModal}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeDeleteConfirmModal}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default Pastconfproceedingsupload;